import { render, staticRenderFns } from "./ClinicToggle.vue?vue&type=template&id=63b5a714"
import script from "./ClinicToggle.vue?vue&type=script&lang=js"
export * from "./ClinicToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports